import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "row p-2",
  slot: "content"
}
const _hoisted_2 = { class: "col-12 col-lg-6 px-5 col-md-5 g-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "form-group col-12" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: " https://www.cms.gov/Medicare/New-Medicare-Card/Providers/Providers-and-office-managers",
    target: "_blank"
  }, " Click here for CMS guidelines on the new Medicare Beneficiary Identifier (MBI) ")
], -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "form-group col-12" }, [
  /*#__PURE__*/_createTextVNode(" MBI usage is required for all Medicare patients. Contact the patient or representative to obtain the 11-digit MBI provided on the patient's Medicare card, and enter it in the patient's chart. If the patient is unaware of his/her MBI, your "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.cms.gov/mac-info",
    target: "_blank"
  }, " Medicare Administrative Contractor's provider portal "),
  /*#__PURE__*/_createTextVNode(" can be used to look up MBIs. ")
], -1 /* HOISTED */)
const _hoisted_5 = { class: "form-group col-12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "mbi-number",
  id: "Mbi_Number_Label"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge me-1" }, "(M0063)"),
  /*#__PURE__*/_createTextVNode(" Medicare Beneficiary Identifier (MBI) Number "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger ms-1" }, "*")
], -1 /* HOISTED */)
const _hoisted_7 = ["value", "disabled"]
const _hoisted_8 = { class: "form-group row" }
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = { class: "form-check custom-checkbox form-check-inline mt-2" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label flex-grow-0",
  for: "referral-medicare-beneficiary-identification-na"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "N/A- Not Applicable")
], -1 /* HOISTED */)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_15 = {
  key: 1,
  class: "field-invalid"
}
const _hoisted_16 = { class: "form-group col-12" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { for: "medicaid-number" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge me-1" }, "(M0065)"),
  /*#__PURE__*/_createTextVNode(" Medicaid Number "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger ms-1" }, "*")
], -1 /* HOISTED */)
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { class: "form-group row" }
const _hoisted_20 = { class: "col-12" }
const _hoisted_21 = { class: "form-check custom-checkbox form-check-inline mt-2" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label flex-grow-0",
  for: "referral-no-medicaid"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "N/A- Not Applicable")
], -1 /* HOISTED */)
const _hoisted_23 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_24 = { class: "form-group col-12" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { for: "medicaid-number" }, " Alternate Medicaid Number ", -1 /* HOISTED */)
const _hoisted_26 = ["disabled"]
const _hoisted_27 = { class: "form-group row" }
const _hoisted_28 = { class: "col-12" }
const _hoisted_29 = { class: "form-check custom-checkbox form-check-inline mt-2" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label flex-grow-0",
  for: "referral-no-medicaid-alternate"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "N/A- Not Applicable")
], -1 /* HOISTED */)
const _hoisted_31 = { class: "mt-3" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", null, "Verify Medicare Eligibility", -1 /* HOISTED */)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = { class: "col-12 col-lg-6 ps-0 pe-5 col-md-5 g-0" }
const _hoisted_35 = { class: "form-group col-12" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { for: "primary-insurance" }, " Primary Insurance ", -1 /* HOISTED */)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Primary Insurance", -1 /* HOISTED */)
const _hoisted_38 = {
  key: 0,
  value: null,
  disabled: ""
}
const _hoisted_39 = ["value"]
const _hoisted_40 = { class: "form-group col-12" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { for: "secondary-insurance" }, " Secondary Insurance ", -1 /* HOISTED */)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Secondary Insurance", -1 /* HOISTED */)
const _hoisted_43 = {
  key: 0,
  value: null,
  disabled: ""
}
const _hoisted_44 = ["value"]
const _hoisted_45 = { class: "form-group col-12" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", { for: "tertiary-insurance" }, " Tertiary Insurance ", -1 /* HOISTED */)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Tertiary Insurance", -1 /* HOISTED */)
const _hoisted_48 = {
  key: 0,
  value: null,
  disabled: ""
}
const _hoisted_49 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MedicarePayorNew = _resolveComponent("MedicarePayorNew")!
  const _component_NonMedicarePayorNew = _resolveComponent("NonMedicarePayorNew")!
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "Payer",
    type: "his-section",
    "full-height": false,
    "application-id": _ctx.referral.application
  }, {
    content: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("input", {
              class: _normalizeClass(["form-control", `${!_ctx.v$.referral.Referral.MbiNumber.$error ? '' : 'field-invalid'}`]),
              maxlength: "11",
              name: "mbi-number",
              type: "text",
              placeholder: "Enter Medicare Beneficiary Identifier (MBI) Number",
              value: _ctx.payorInfoValues.MbiNumber,
              disabled: _ctx.payorInfoNotapplicable.MbiNumber && !_ctx.insurerInfo.primary.isMedicare,
              onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.payorInfoChanged(_ctx.referral.Referral, 'MbiNumber'))),
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setMbiNumber($event.target.value))),
              onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Referral.MbiNumber.$touch && _ctx.v$.referral.Referral.MbiNumber.$touch(...args)))
            }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_7),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "referral-medicare-beneficiary-identification-na",
                    class: "form-check-input au-target",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.payorInfoNotapplicable.MbiNumber) = $event)),
                    disabled: _ctx.insurerInfo.primary.isMedicare,
                    onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.payorInfoChanged(_ctx.referral.Referral, 'MbiNumber')))
                  }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_11), [
                    [_vModelCheckbox, _ctx.payorInfoNotapplicable.MbiNumber]
                  ]),
                  _hoisted_12
                ])
              ])
            ]),
            (_ctx.v$.referral.Referral.MbiNumber.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                  (_ctx.v$.referral.Referral.MbiNumber.$errors[0].$message == 'Value is required')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, "MBI number is required"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_15, "Please enter 11 alpha-numeric characters."))
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass(["form-control", `${!_ctx.v$.referral.Referral.MedicaidNumber.$error ? '' : 'field-invalid'}`]),
              maxlength: "50",
              placeholder: "Enter Medicaid Number",
              name: "medicaid-number",
              type: "text",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.payorInfoValues.MedicaidNumber) = $event)),
              onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.payorInfoChanged(_ctx.referral.Referral, 'MedicaidNumber'))),
              disabled: _ctx.payorInfoNotapplicable.MedicaidNumber,
              onBlur: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Referral.MedicaidNumber.$touch && _ctx.v$.referral.Referral.MedicaidNumber.$touch(...args)))
            }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_18), [
              [_vModelText, _ctx.payorInfoValues.MedicaidNumber]
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "referral-no-medicaid",
                    name: "other-medicaid",
                    class: "form-check-input au-target",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.payorInfoNotapplicable.MedicaidNumber) = $event)),
                    onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.payorInfoChanged(_ctx.referral.Referral, 'MedicaidNumber')))
                  }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                    [_vModelCheckbox, _ctx.payorInfoNotapplicable.MedicaidNumber]
                  ]),
                  _hoisted_22
                ])
              ])
            ]),
            (_ctx.v$.referral.Referral.MedicaidNumber.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_23, "Medicaid number is required."))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              maxlength: "50",
              placeholder: "Enter Alternate Medicaid Number",
              name: "medicaid-number-alternate",
              type: "text",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.payorInfoValues.AlternateMedicaidNumber) = $event)),
              onInput: _cache[11] || (_cache[11] = ($event: any) => (_ctx.payorInfoChanged(_ctx.referral.ReferralExtension, 'AlternateMedicaidNumber'))),
              disabled: _ctx.payorInfoNotapplicable.AlternateMedicaidNumber
            }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_26), [
              [_vModelText, _ctx.payorInfoValues.AlternateMedicaidNumber]
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "referral-no-medicaid-alternate",
                    name: "other-medicaid",
                    class: "form-check-input au-target",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.payorInfoNotapplicable.AlternateMedicaidNumber) = $event)),
                    onChange: _cache[13] || (_cache[13] = ($event: any) => (
                                            _ctx.payorInfoChanged(_ctx.referral.ReferralExtension, 'AlternateMedicaidNumber')
                                        ))
                  }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                    [_vModelCheckbox, _ctx.payorInfoNotapplicable.AlternateMedicaidNumber]
                  ]),
                  _hoisted_30
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("button", {
                class: "btn btn-xs btn-primary p-1",
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.verifyEligibility()))
              }, _hoisted_33)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _withDirectives(_createElementVNode("select", {
              id: "primary-insurance",
              class: "form-select",
              onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.payorChanged(_ctx.referral.Referral.PrimaryInsurance, 'primary'))),
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.referral.Referral.PrimaryInsurance) = $event))
            }, [
              _hoisted_37,
              (!_ctx.referral.Referral.BranchId)
                ? (_openBlock(), _createElementBlock("option", _hoisted_38, " Please Select Agency Branch in the Demographics Tab "))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.primaryInsurance, (insurance, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: index,
                      value: insurance.value
                    }, _toDisplayString(insurance.text), 9 /* TEXT, PROPS */, _hoisted_39))
                  }), 128 /* KEYED_FRAGMENT */))
            ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
              [_vModelSelect, _ctx.referral.Referral.PrimaryInsurance]
            ])
          ]),
          (_ctx.insurerInfo.primary?.isMedicare !== null && _ctx.insurerInfo.primary?.isMedicare)
            ? (_openBlock(), _createBlock(_component_MedicarePayorNew, {
                key: 0,
                "referral-options": _ctx.referralOptions,
                referral: _ctx.referral,
                insurer: _ctx.insurerInfo.primary
              }, null, 8 /* PROPS */, ["referral-options", "referral", "insurer"]))
            : _createCommentVNode("v-if", true),
          (_ctx.insurerInfo.primary?.isMedicare !== null && !_ctx.insurerInfo.primary?.isMedicare)
            ? (_openBlock(), _createBlock(_component_NonMedicarePayorNew, {
                key: 1,
                "referral-options": _ctx.referralOptions,
                referral: _ctx.referral,
                insurer: _ctx.insurerInfo.primary,
                clearAddressfields: _ctx.clearAddressfields
              }, null, 8 /* PROPS */, ["referral-options", "referral", "insurer", "clearAddressfields"]))
            : _createCommentVNode("v-if", true),
          (_ctx.secondaryInsurance.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("div", _hoisted_40, [
                  _hoisted_41,
                  _withDirectives(_createElementVNode("select", {
                    id: "secondary-insurance",
                    class: "form-select",
                    onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.payorChanged(_ctx.referral.Referral.SecondaryInsurance, 'secondary'))),
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.referral.Referral.SecondaryInsurance) = $event))
                  }, [
                    _hoisted_42,
                    (!_ctx.referral.Referral.BranchId)
                      ? (_openBlock(), _createElementBlock("option", _hoisted_43, " Please Select Agency Branch in the Demographics Tab "))
                      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.secondaryInsurance, (insurance, index) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: index,
                            value: insurance.value
                          }, _toDisplayString(insurance.text), 9 /* TEXT, PROPS */, _hoisted_44))
                        }), 128 /* KEYED_FRAGMENT */))
                  ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                    [_vModelSelect, _ctx.referral.Referral.SecondaryInsurance]
                  ])
                ]),
                (_ctx.insurerInfo.secondary.isMedicare !== null && _ctx.insurerInfo.secondary?.isMedicare)
                  ? (_openBlock(), _createBlock(_component_MedicarePayorNew, {
                      key: 0,
                      "referral-options": _ctx.referralOptions,
                      referral: _ctx.referral,
                      insurer: _ctx.insurerInfo.secondary
                    }, null, 8 /* PROPS */, ["referral-options", "referral", "insurer"]))
                  : _createCommentVNode("v-if", true),
                (_ctx.insurerInfo.secondary?.isMedicare !== null && !_ctx.insurerInfo.secondary?.isMedicare)
                  ? (_openBlock(), _createBlock(_component_NonMedicarePayorNew, {
                      key: 1,
                      insurer: _ctx.insurerInfo.secondary,
                      "referral-options": _ctx.referralOptions,
                      referral: _ctx.referral,
                      clearAddressfields: _ctx.clearAddressfields
                    }, null, 8 /* PROPS */, ["insurer", "referral-options", "referral", "clearAddressfields"]))
                  : _createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          (_ctx.tertiaryInsurance.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createElementVNode("div", _hoisted_45, [
                  _hoisted_46,
                  _withDirectives(_createElementVNode("select", {
                    id: "tertiary-insurance",
                    class: "form-select",
                    onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.payorChanged(_ctx.referral.Referral.TertiaryInsurance, 'tertiary'))),
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.referral.Referral.TertiaryInsurance) = $event))
                  }, [
                    _hoisted_47,
                    (!_ctx.referral.Referral.BranchId)
                      ? (_openBlock(), _createElementBlock("option", _hoisted_48, " Please Select Agency Branch in the Demographics Tab "))
                      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.tertiaryInsurance, (insurance, index) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: index,
                            value: insurance.value
                          }, _toDisplayString(insurance.text), 9 /* TEXT, PROPS */, _hoisted_49))
                        }), 128 /* KEYED_FRAGMENT */))
                  ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                    [_vModelSelect, _ctx.referral.Referral.TertiaryInsurance]
                  ])
                ]),
                (_ctx.insurerInfo.tertiary?.isMedicare !== null && _ctx.insurerInfo.tertiary?.isMedicare)
                  ? (_openBlock(), _createBlock(_component_MedicarePayorNew, {
                      key: 0,
                      "referral-options": _ctx.referralOptions,
                      referral: _ctx.referral,
                      insurer: _ctx.insurerInfo.tertiary
                    }, null, 8 /* PROPS */, ["referral-options", "referral", "insurer"]))
                  : _createCommentVNode("v-if", true),
                (_ctx.insurerInfo.tertiary?.isMedicare !== null && !_ctx.insurerInfo.tertiary?.isMedicare)
                  ? (_openBlock(), _createBlock(_component_NonMedicarePayorNew, {
                      key: 1,
                      insurer: _ctx.insurerInfo.tertiary,
                      "referral-options": _ctx.referralOptions,
                      referral: _ctx.referral,
                      clearAddressfields: _ctx.clearAddressfields
                    }, null, 8 /* PROPS */, ["insurer", "referral-options", "referral", "clearAddressfields"]))
                  : _createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}